module.exports = __webpack_public_path__ + "static/img/20231208_07.c535e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231208_07.png
// module id = QBZd
// module chunks = 0